/**
 * Parent theme — le cockpit sur la nuit (Brand core V13, « Clair et sombre, au choix »).
 *
 * Le socle de la nuit (`nightBase.ts`, qui énumère les trois mouvements), plus ce que l'univers du
 * parent y devient : **il s'inverse**. Côté clair, l'univers du parent EST le marine — il remplit
 * le bouton principal, dont l'encre est blanche. Sur la nuit, le livre dessine l'inverse (chap. 06,
 * « MODE SOMBRE ») : bouton BLANC, libellé marine, relief gris clair. `role` et son bouton suivent
 * donc le marine du socle, jeton pour jeton.
 */
import { baseTheme } from "./base"
import { nightBaseColors } from "./nightBase"
import { brand, night } from "./tokens/colors"

export const parentDarkTheme = {
    ...baseTheme,
    colors: {
        ...baseTheme.colors,
        ...nightBaseColors,

        role: brand.white,
        "role-strong": brand.white,
        "role-selected": brand.white,
        "role-fill": brand.white,
        "relief-role": night.relief,
        "text-on-role": brand.marine,
        "text-link": brand.white,
    },
} as const
